import { type Reducer } from "redux";
import { type ImperialMetricDataState, initialImperialMetricDataState } from "./ImperialMetricDataState";
import { type UnitMode } from "./UnitMode";

export const CHANGE_UNIT_MODE = "global: change unit mode";

export function changeUnitModeAction(newMode: UnitMode) {
  return {
    type: CHANGE_UNIT_MODE,
    payload: newMode,
  };
}

type ImperialMetricActions = ReturnType<typeof changeUnitModeAction>;

export const imperialMetricDataReducer: Reducer<ImperialMetricDataState, ImperialMetricActions> = (
  state = initialImperialMetricDataState,
  action
): ImperialMetricDataState => {
  switch (action.type) {
    case CHANGE_UNIT_MODE: {
      return {
        ...state,
        unitMode: action.payload,
      };
    }
    default:
      return state;
  }
};
